// GSAP CONFIG 
gsap.registerPlugin(SplitText, ScrollTrigger);
gsap.config({ nullTargetWarn: false });